import { render, staticRenderFns } from "./goods-swipe.vue?vue&type=template&id=5ffe96be&scoped=true&"
import script from "./goods-swipe.vue?vue&type=script&lang=js&"
export * from "./goods-swipe.vue?vue&type=script&lang=js&"
import style0 from "./goods-swipe.vue?vue&type=style&index=0&id=5ffe96be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffe96be",
  null
  
)

export default component.exports